import Axios from "axios";
import store from "@/shared/store/index";

class BaseService {
  Start() {
    this.StartRequest();
    this.StartResponse();
  }

  StartResponse() {
    let that = this;
    Axios.interceptors.response.use(
      function(response) {
        if (response.headers["x-authorization-new"]) {
          store.commit(
            "setTokenBearer",
            response.headers["x-authorization-new"]
          );
        }
        return response;
      },
      function(err) {
        if (that.verificarResponseCancelada(err)) {
          return store.dispatch("criarErroGenerico", {
            cancelado: true
          });
        }
        that.verificarResponseUndefined(err);
        that.verificarResponseBlob(err);
        return Promise.reject(store.dispatch("criarErroGenerico", err));
      }
    );
  }

  /**
   * Verifica se a Response está undefined, útil quando ocorre erro de cors
   * @param { Error } err - Erro padrão do axios
   * @return { Promise.reject }
   *         Retorna a rejeição de uma promise para que seja possível recuperar o erro na respectiva service.
   *         Também chama uma função da store para que seja mostrada a modal de erro.
   */
  verificarResponseUndefined(err) {
    if (Axios.isCancel(err)) return;

    if (typeof err.response === "undefined") {
      return Promise.reject(
        store.dispatch("criarErroGenerico", {
          response: {
            data:
              "O sistema aparentemente está indisponível, tente novamente mais tarde!",
            status: 503,
            headers: {}
          }
        })
      );
    }
  }

  /**
   * Verifica se a Response foi cancelada
   * @param { Error } err - Erro padrão do axios
   * @return { Boolean }
   */
  verificarResponseCancelada(err) {
    return Axios.isCancel(err);
  }

  /**
   * Verifica se a Response é do tipo Blob
   * @param { Error } err - Erro padrão do axios
   * @return { Promise.reject }
   *         Retorna a rejeição de uma promise para que seja possível recuperar o erro na respectiva service.
   *         Também chama uma função da store para mostrar a modal de erro.
   */
  verificarResponseBlob(err) {
    if (Axios.isCancel(err)) return;

    if (
      err.request.responseType === "blob" &&
      err.response.data instanceof Blob &&
      err.response.data.type &&
      err.response.data.type.toLowerCase().indexOf("json") != -1
    ) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.onload = () => {
          err.response.data = JSON.parse(reader.result);
          resolve(Promise.reject(store.dispatch("criarErroGenerico", err)));
        };

        reader.onerr = () => {
          reject(err);
        };

        reader.readAsText(err.response.data);
      });
    }
  }

  StartRequest() {
    Axios.interceptors.request.use(
      function(request) {
        request.headers["Content-Type"] = "application/json;charset=UTF-8";
        request.headers["Authorization"] = store.getters.getTokenBearer;
        request.withCredentials = true;

        //TO DO - limpar essa função
        if (!request.url.endsWith("usuario/foto-atual")) {
          let source = Axios.CancelToken.source();
          request.cancelToken = source.token;
          store.commit("ADD_CANCEL_TOKEN", source);
        }

        return request;
      },
      function(err) {
        return Promise.reject(err);
      }
    );
  }
}

export default new BaseService();
